var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('app-header',{class:{
      'is-hidden':
        _vm.$route.path === '/' ||
        _vm.$route.path === '/question'
    }}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }